// Module
var code = "<template> <div ref=\"calendarElement\" class=\"calendar-wrapper h-100\"></div> </template> ";
// Exports
export default code;